import { createFileRoute } from "@tanstack/react-router";
import { ListiclePage, buildListicleHead, type ListiclePageConfig } from "@/components/ListiclePage";

const CONFIG: ListiclePageConfig = {
  slug: "top-colorado-local-seo-wins-this-year",
  metaTitle: "Top Colorado Local SEO Wins We've Shipped This Year | Colorado Web Impressions",
  metaDescription: "A round-up of the highest-ROI local SEO moves we've shipped for Colorado clients in the last 12 months. Most are repeatable for any service business.",
  breadcrumbs: [
    { label: "Home", to: "/" },
    { label: "Insights", to: "/learn" },
  ],
  currentLabel: "Recent Wins — Colorado",
  eyebrow: "Recent Wins — Colorado",
  h1: <>{"Top Colorado Local SEO Wins We've Shipped This Year"}</>,
  heroDescription: "A round-up of the highest-ROI local SEO moves we've shipped for Colorado clients in the last 12 months.",
  intro: "A round-up of the highest-ROI local SEO moves we've shipped for Colorado clients in the last 12 months. Most are repeatable for any service business.",
  methodology: ["Based on real Colorado small business audits and projects", "Ranked by revenue impact, not opinion", "Patterns are repeatable — no proprietary tools required", "Updated quarterly as Colorado SERPs shift"],
  items: [
    {
      rank: 1,
      name: "HVAC client: 4x Map Pack visibility in 90 days",
      whatWeLike: ["Service-area page build-out + 60-review push + weekly GBP posts. From position 12 to top 3 across 5 cities."],
    },
    {
      rank: 2,
      name: "Plumber: 2.1x organic leads in 6 months",
      whatWeLike: ["Hand-coded site rebuild + 22 new service pages + schema across the board. Conversion rate doubled before SEO even kicked in."],
    },
    {
      rank: 3,
      name: "Law firm: ranked #1 for primary practice-area term",
      whatWeLike: ["Topical clusters around the practice area + author E-E-A-T pages. Now owns the local SERP."],
    },
    {
      rank: 4,
      name: "Roofer: $180k pipeline from one storm landing page",
      whatWeLike: ["Hail-storm landing page launched within 48 hours of event. Zero ad spend, all organic."],
    },
    {
      rank: 5,
      name: "Dental: doubled new-patient bookings",
      whatWeLike: ["Same-day appointment schema + insurance badges + new-patient form. Lifted booked rate from 8% to 19%."],
    },
    {
      rank: 6,
      name: "Med spa: ranked for 14 new procedure terms",
      whatWeLike: ["Per-procedure page expansion with pricing and FAQs. Each ranks independently in the local pack."],
    },
    {
      rank: 7,
      name: "Concrete contractor: 3x quote requests",
      whatWeLike: ["Switched from one services page to nine. Each ranks for its own intent."],
    },
    {
      rank: 8,
      name: "Auto repair: 87 new Google reviews in 60 days",
      whatWeLike: ["SMS review request flow tied to invoice close. Compounding ranking lift."],
    }
  ],
  closing: "None of these are tricks. They're the boring fundamentals done at a level competitors aren't willing to match.",
  relatedLinks: [
    { to: "/case-studies", label: "case studies" },
    { to: "/local-seo", label: "local seo" },
    { to: "/colorado-springs", label: "colorado springs" }
  ],
};

export const Route = createFileRoute("/top-colorado-local-seo-wins-this-year")({
  head: () => buildListicleHead(CONFIG),
  component: () => <ListiclePage config={CONFIG} />,
});
